import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-redirect-app-stores-page',
    templateUrl: './redirect-app-stores-page.component.html',
    styleUrl: './redirect-app-stores-page.component.scss',
    standalone: false
})
export class RedirectAppStoresPageComponent {
  private readonly googlePlayStoreUrl = 'https://play.google.com/store/apps/details?id=com.almostlevel5.planetvg.loyalty.store';
  private readonly appleAppStoreUrl = 'https://apps.apple.com/app/planet-vg-store/id6505109752';

  private timeLeft: number = 1;
  private timer: any;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly deviceService: DeviceDetectorService,
    private readonly router: Router,
  ) {
    // Do nothing
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.startTimer();
      this.redirectBasedOnDevice();
    }
  }

  ngOnDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }

  redirectBasedOnDevice() {
    const deviceInfo = this.deviceService.getDeviceInfo();
    switch (deviceInfo.os.toLowerCase()) {
      case 'ios':
        window.location.href = this.appleAppStoreUrl;
        this.startTimer();
        break;
      case 'android':
      default:
        window.location.href = this.googlePlayStoreUrl;
        break;
    }
  }

  startTimer(): void {
    this.timer = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.router.navigate(['/']);
      }
    }, 1000);
  }
}
